import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SnotifyService } from 'ng-snotify';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Tag } from 'src/app/shared/models/tag.model';
import { RowAction } from 'src/app/shared/base-reporting/models/row-actions.interface';
import { FilterItem } from 'src/app/shared/base-reporting/models/filter-item.interface';
import { FilterCallback } from 'src/app/shared/base-reporting/models/filter-callback.interface';
import { RowActionCallback } from 'src/app/shared/base-reporting/models/row-action-callback.interface';
import { TagsService } from '../tags.service';

@Component({
  selector: 'app-tag-list',
  templateUrl: './tag-list.component.html',
  styleUrls: ['./tag-list.component.css']
})
export class TagListComponent implements OnInit {
  tag = new Tag();
  tableColumns = ['title', 'groupId'];
  rowActions: Array<RowAction> = [
    {
      type: 'icon',
      slug: 'editTag',
      class: 'btn',
      iconClasses: 'fa fa-edit'
    },
    {
      type: 'icon',
      slug: 'deleteTag',
      class: 'btn',
      iconClasses: 'fa fa-trash'
    }
  ];
  reportFilter: Array<FilterItem> = [
    {
      fieldName: 'title',
      fieldDisplayName: 'Title ',
      fieldType: 'text'
    },
    {
      fieldName: 'groupId',
      fieldDisplayName: 'Group Name',
      fieldType: 'text'
    },
    // {
    //   fieldName: 'createdAt',
    //   fieldDisplayName: 'created At ',
    //   fieldType: 'daterange'
    // },
  ];
  private Data = [] as Array<TableViewItem>;
  currentFilterObject = {} as FilterModel;
  constructor(
    private tagApi: TagsService,
    private notifier: SnotifyService,
    private router: Router,
    private datePipe: DatePipe
  ) {}

  get data(): Array<TableViewItem> {
    return this.Data
    // .filter(row => {
    //   if (
    //     this.currentFilterObject.createdAt &&
    //     this.currentFilterObject.createdAt.startDate &&
    //     this.currentFilterObject.createdAt.endDate
    //   ) {
    //     return moment(row.createdAt).isBetween(
    //       // @ts-ignore
    //       this.currentFilterObject.expiresAt.startDate._i,
    //       // @ts-ignore
    //       this.currentFilterObject.expiresAt.endDate._i
    //     );
    //   } else {
    //     return true;
    //   }
    // })
    .filter(row => {
      if (this.currentFilterObject.title) {
        return row.title.includes(this.currentFilterObject.title);
      }
      return true;
    }) .filter(row => {
      if (this.currentFilterObject.groupId) {
        return row.groupId.includes(this.currentFilterObject.groupId);
      }
      return true;
    });
  }
  set data(v: Array<TableViewItem>) {
    this.Data = v;
  }

  ngOnInit() {
    this.fetchAllTags();
  }

  onFilter(event: FilterCallback) {
    this.currentFilterObject = event.filter;
  }

  private fetchAllTags() {
    this.tagApi.getTags().subscribe(response => {
      console.log(response)
      this.data = response.data.tags.map(r => {
        return {
          id: r.id,
          title: r.name,
          groupId: r.group ? r.group.name : null,
        } as TableViewItem;
      });
    });
  }
  rowActionCB(event: RowActionCallback) {
    switch (event.action) {
      case 'editTag':
        this.tag = event.on;
        this.router.navigateByUrl('/filters/tag/edit/' + this.tag.id);
        break;
      case 'deleteTag':
        this.tag = event.on;
        break;
      default:
        console.error('this is a mistake!');
    }
  }
  fetchTable(event) {
    if (event[`flag`] === true) {
      this.fetchAllTags();
    }
  }
}

interface TableViewItem {
  title?: string;
  groupId?: string;
}

interface FilterModel {
  title?: string;
  groupId?: string;
}

// interface DateRangeModel {
//   startDate?: moment.Moment;
//   endDate?: moment.Moment;
// }
